// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xhvc","type":"styles_type__3ZlvK","choices":"styles_choices__2b9vr"};